import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";

export class Generic_Responsive extends SlotGameType1_Responsive
{
}